import React from "react";

import { Button, makeStyles } from "@material-ui/core";

const useStyle = (width, bg, borderColor, gutter) =>
  makeStyles((theme) => ({
    buttonStyle: {
      margin: theme.spacing(...gutter),
      borderRadius: theme.spacing(4),
      textTransform: "none",
      height: 56,
      backgroundColor: bg,

      width: width,
      padding: 1,
      border: `1px solid ${borderColor}`,
    },
  }));

export default function PopperButton({
  width,
  bg,
  color,
  borderColor,
  gutter,
  ...rest
}) {
  const style = useStyle(width, bg, borderColor, gutter)();

  return <Button className={style.buttonStyle} {...rest} />;
}

PopperButton.defaultProps = {
  width: "100%",
  bg: "#fff",
  borderColor: "white",
  gutter: [0],
};
